export const MuiIconButton = palette => ({
  styleOverrides: {
    root: {
      ':hover': {
        backgroundColor: palette.card.hover
      }
    }
  }
})
